import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Container,
  Fade,
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  Modal,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const SignUp: React.FC = () => {
  const [openPopup, setOpenPopup] = useState(false);
  const [userType, setUserType] = useState("individual");
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    password: "",
    confirmPassword: "",
    companyName: "",
    website: "",
  });

  useEffect(() => {
    const timer = setTimeout(() => {
      setOpenPopup(true);
    }, 1000);
    return () => clearTimeout(timer);
  }, []);

  const handleClosePopup = () => {
    setOpenPopup(false);
  };

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | { name?: string; value: unknown }>
  ) => {
    const { name, value } = e.target as HTMLInputElement;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleUserTypeChange = (e: React.ChangeEvent<{ value: unknown }>) => {
    setUserType(e.target.value as string);
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log("Submitted Data:", { userType, ...formData });
  };

  return (
    <Modal open={openPopup} onClose={handleClosePopup} closeAfterTransition>
      <Fade in={openPopup}>
       

          {/* SignUp Form Container */}
          <Container
            maxWidth="sm"
            sx={{
              mt: 8,
              bgcolor: "white",
              p: 4,
              borderRadius: 2,
              boxShadow: 3,
              zIndex: 10,
              position: "relative",
            }}
          >
            {/* Close Button */}
            <IconButton
              onClick={handleClosePopup}
              sx={{
                position: "absolute",
                top: 8,
                right: 8,
                color: "grey.600",
              }}
            >
              <CloseIcon />
            </IconButton>

            <Typography variant="h5" fontWeight={600} gutterBottom align="center">
              Sign Up
            </Typography>

            <Box component="form" onSubmit={handleSubmit} noValidate>
              <FormControl fullWidth sx={{ mb: 2 }}>
                <InputLabel>User Type</InputLabel>
                <Select
                  value={userType}
                  onChange={handleUserTypeChange}
                  label="User Type"
                >
                  <MenuItem value="individual">Individual</MenuItem>
                  <MenuItem value="business">Business</MenuItem>
                </Select>
              </FormControl>

              <TextField
                label="Full Name"
                name="fullName"
                fullWidth
                value={formData.fullName}
                onChange={handleChange}
                sx={{ mb: 2 }}
              />

              <TextField
                label="Email"
                name="email"
                fullWidth
                value={formData.email}
                onChange={handleChange}
                sx={{ mb: 2 }}
              />

              <TextField
                label="Password"
                name="password"
                type="password"
                fullWidth
                value={formData.password}
                onChange={handleChange}
                sx={{ mb: 2 }}
              />

              <TextField
                label="Confirm Password"
                name="confirmPassword"
                type="password"
                fullWidth
                value={formData.confirmPassword}
                onChange={handleChange}
                sx={{ mb: 2 }}
              />

              {userType === "business" && (
                <>
                  <TextField
                    label="Company Name"
                    name="companyName"
                    fullWidth
                    value={formData.companyName}
                    onChange={handleChange}
                    sx={{ mb: 2 }}
                  />

                  <TextField
                    label="Website"
                    name="website"
                    fullWidth
                    value={formData.website}
                    onChange={handleChange}
                    sx={{ mb: 2 }}
                  />
                </>
              )}

              <Button type="submit" variant="contained" fullWidth>
                Register
              </Button>
            </Box>
          </Container>
      </Fade>
    </Modal>
  );
};

export default SignUp;